import React from "react";
import { LandingContextProps } from "./types";

const initialState = {
  formOpen: false,
  offersMode: false
};
const LandingContext = React.createContext<LandingContextProps>(initialState);

export { LandingContext, LandingContextProps };
